import React, { useState } from 'react';
import { Form } from 'reactstrap';
import { Search, ChevronDown, ChevronUp, RotateCcw, UserPlus } from 'react-feather';
import Loader from '../../../layouts/loader/Loader';
import '../../../assets/styles/login/styles.css';
import useFormularioUsuarios from './hooks/useFormularioUsuarios';
import FiltrosBusqueda from './FiltrosBusqueda';
import TablaResultados from './TablaResultados';
import colors from '../../../theme/colors';

const FormularioUsuarios = () => {
  const [showFilters, setShowFilters] = useState(true);
  const {
    name, lastname, dni, idUser, email, phone, idStripe,
    headquarter, year, cicle, type, course,
    formationCenter, deudores, selectedIds, setSelectedIds,
    headquarterList, formationList, yearList, typeList, cicleList, courseList,
    data, searchMeta, isFormSubmittable, isTableNotLoading, isLoadingMore, loadMore, userOU, searchContext,
    handleNameOnChange, handleLastNameOnChange, handleDNIOnChange,
    handleIDOnChange, handleEmailOnChange, handlePhoneOnChange,
    handleHeadquarter, handleFormationCenter, handleYear,
    handleType, handleCicle, handleCourse, handleDeudor,
    handleIdStripeOnChange, handleReset, handleOnSubmit, handleNavigateNuevoAlumno,
  } = useFormularioUsuarios();

  const isReady =
    headquarterList !== '' && cicleList !== '' &&
    typeList !== '' && courseList !== '' && userOU !== '';

  if (!isReady) return <Loader />;

  return (
    <>
      <Form onSubmit={handleOnSubmit}>
        <div
          style={{
            backgroundColor: '#fff',
            borderRadius: '12px',
            border: '1px solid #e5e7eb',
            boxShadow: '0 1px 3px rgb(0 0 0 / 0.06)',
            overflow: 'visible',
          }}
        >
          {/* Toolbar */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '12px 16px',
              borderBottom: showFilters ? '1px solid #f3f4f6' : 'none',
            }}
          >
            <button
              type="button"
              onClick={() => setShowFilters(!showFilters)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: '0.8rem',
                fontWeight: 600,
                color: '#374151',
                padding: '4px 8px',
                borderRadius: '6px',
              }}
            >
              <Search size={15} style={{ color: '#9ca3af' }} />
              Filtros
              {showFilters
                ? <ChevronUp size={14} style={{ color: '#9ca3af' }} />
                : <ChevronDown size={14} style={{ color: '#9ca3af' }} />}
            </button>

            <div style={{ display: 'flex', gap: '8px' }}>
              <button
                type="button"
                onClick={handleReset}
                disabled={!isTableNotLoading}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '5px',
                  padding: '6px 12px',
                  fontSize: '0.75rem',
                  fontWeight: 600,
                  borderRadius: '6px',
                  border: '1px solid #e5e7eb',
                  backgroundColor: '#fff',
                  color: '#6b7280',
                  cursor: 'pointer',
                  transition: 'all 0.15s',
                }}
              >
                <RotateCcw size={13} />
                Limpiar
              </button>

              <button
                type="submit"
                disabled={!isFormSubmittable || !isTableNotLoading}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '5px',
                  padding: '6px 14px',
                  fontSize: '0.75rem',
                  fontWeight: 600,
                  borderRadius: '6px',
                  border: 'none',
                  backgroundColor: colors.primary,
                  color: '#fff',
                  cursor: (!isFormSubmittable || !isTableNotLoading) ? 'not-allowed' : 'pointer',
                  opacity: (!isFormSubmittable || !isTableNotLoading) ? 0.5 : 1,
                  transition: 'all 0.15s',
                }}
              >
                <Search size={13} />
                {!isTableNotLoading ? 'Buscando...' : 'Buscar'}
              </button>

              <button
                type="button"
                onClick={handleNavigateNuevoAlumno}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '5px',
                  padding: '6px 14px',
                  fontSize: '0.75rem',
                  fontWeight: 600,
                  borderRadius: '6px',
                  border: `1px solid ${colors.primary}`,
                  backgroundColor: '#fff',
                  color: colors.primary,
                  cursor: 'pointer',
                  transition: 'all 0.15s',
                }}
              >
                <UserPlus size={13} />
                Nuevo
              </button>
            </div>
          </div>

          {/* Filtros colapsables */}
          {showFilters && (
            <div style={{
              padding: '16px',
              opacity: !isTableNotLoading ? 0.5 : 1,
              pointerEvents: !isTableNotLoading ? 'none' : 'auto',
              transition: 'opacity 0.2s',
            }}>
              <FiltrosBusqueda
                searchContext={searchContext}
                isTableNotLoading={isTableNotLoading}
                name={name} lastname={lastname} dni={dni} idUser={idUser}
                email={email} phone={phone} idStripe={idStripe}
                headquarter={headquarter} headquarterList={headquarterList}
                year={year} yearList={yearList}
                type={type} typeList={typeList}
                cicle={cicle} cicleList={cicleList}
                course={course} courseList={courseList}
                formationList={formationList} formationCenter={formationCenter}
                selectedIds={selectedIds} setSelectedIds={setSelectedIds}
                deudores={deudores} userOU={userOU}
                handleNameOnChange={handleNameOnChange}
                handleLastNameOnChange={handleLastNameOnChange}
                handleDNIOnChange={handleDNIOnChange}
                handleIDOnChange={handleIDOnChange}
                handleYear={handleYear}
                handleHeadquarter={handleHeadquarter}
                handleType={handleType}
                handleCicle={handleCicle}
                handleCourse={handleCourse}
                handleEmailOnChange={handleEmailOnChange}
                handleFormationCenter={handleFormationCenter}
                handlePhoneOnChange={handlePhoneOnChange}
                handleIdStripeOnChange={handleIdStripeOnChange}
                handleDeudor={handleDeudor}
              />
            </div>
          )}
        </div>
      </Form>
      <TablaResultados data={data} searchMeta={searchMeta} onLoadMore={loadMore} isLoadingMore={isLoadingMore} />
    </>
  );
};

export default FormularioUsuarios;
